const doc = [({"da":({"js":({"admin":({"agenda_item_elements":({"create_card":({"create_agenda_item_element":"Opret dagsordenspunktselement"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;